import { css } from '@emotion/react';
import BrandedLogo from '../BrandedLogo';
import Container from '../Container';
import { LegalFooterDesktop } from '../LegalFooter';

const PageContainerDesktop = ({ title, children }) => {
    const headerCSS = ({ black }) => {
        return css`
            font-size: 2rem;
            font-weight: bold;
            color: ${black};
            margin: 0;
        `;
    };

    const desktopRootCSS = css`
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100vh;
        font-size: 1.5rem;

        & > div:first-of-type {
            margin-bottom: 3.333rem;
            margin-top: auto;
            padding-top: 40px;
        }

        & > div:last-of-type {
            margin-top: 1.667rem;
            margin-bottom: auto;
            padding-bottom: 40px;
            width: 500px;
        }
    `;

    return (
        <div css={desktopRootCSS}>
            <BrandedLogo />
            <Container>
                <h1 css={headerCSS}>{title}</h1>
                <main>{children}</main>
            </Container>
            <LegalFooterDesktop />
        </div>
    );
};

export default PageContainerDesktop;
